<template>
  <div class="main-page-wrapper">
    <Overview v-if="switch_tab == 'overview'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></Overview>
    <Events v-if="switch_tab == 'events'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></Events>
    <Projects v-if="switch_tab == 'projects'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></Projects>
    <AccountContacts v-if="switch_tab == 'account-contact'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></AccountContacts>
    <LiaGeneration v-if="switch_tab == 'lia-generation'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></LiaGeneration>
    <Attachments v-if="switch_tab == 'attachments'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></Attachments>
    <Notes v-if="switch_tab == 'activities'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></Notes>
    <Activities v-if="false" @tab="(tab) => {
      switch_tab = tab;
    }
      "></Activities>
    <Task v-if="switch_tab == 'tasks'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></Task>
    <Lead v-if="switch_tab == 'leads'" @tab="(tab) => {
      switch_tab = tab;
    }
      "></Lead>
  </div>
</template>
<script>
import Overview from "@/views/Accounts/AccountsView/Overview.vue";
import Projects from "@/views/Accounts/AccountsView/Projects.vue";
import AccountContacts from "@/views/Accounts/AccountsView/AccountContacts.vue";
import LiaGeneration from "@/views/Accounts/AccountsView/LiaGenelationContacts.vue";
import Attachments from "@/views/Accounts/AccountsView/Attachments.vue";
import Notes from "@/views/Accounts/AccountsView/Notes.vue";
import Activities from "@/views/Accounts/AccountsView/Activities.vue";
import Task from "@/views/Accounts/AccountsView/Task.vue";
import Lead from "@/views/Accounts/AccountsView/Lead.vue";
export default {
  name: "account-view",
  components: {
    Overview,
    Projects,
    AccountContacts,
    LiaGeneration,
    Attachments,
    Notes,
    Activities,
    Task,
    Lead,
  },
  data() {
    return {
      switch_tab: "overview",
      account: {},
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      vm.switch_tab = val;
    },
  },
  mounted() {
    let vm = this;
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.main-page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f5f5f5;
}
</style>
